import type { MenuItem } from '../types/navigation';

// Menú administrativo basado en políticas RBAC/ABAC
// Las rutas deben corresponder con las definidas en App.tsx
export const ADMIN_MENU: MenuItem[] = [
  {
    id: 'dashboard',
    labelKey: 'admin.menu.dashboard',
    to: '/admin/dashboard',
    policies: [
      { type: 'role', role: 'admin_general' },
      { type: 'role', role: 'admin_blog' },
      { type: 'role', role: 'admin_comunidad' },
      { type: 'role', role: 'admin_descuentos' },
      { type: 'role', role: 'moderador' },
      { type: 'role', role: 'soporte' },
      { type: 'role', role: 'autor' },
    ],
  },
  {
    id: 'orders',
    labelKey: 'admin.menu.orders',
    to: '/admin/orders',
    policies: [ { type: 'role', role: 'admin_general' } ],
  },
  {
    id: 'users',
    labelKey: 'admin.menu.users',
    to: '/admin/users',
    policies: [
      { type: 'can', action: 'user.manage', resource: 'users' },
      { type: 'can', action: 'role.assign', resource: 'users' },
    ],
  },
  {
    id: 'blog',
    labelKey: 'admin.menu.blog',
    policies: [
      { type: 'can', action: 'blog.view', resource: 'blog' },
      { type: 'can', action: 'blog.create', resource: 'blog' },
      { type: 'can', action: 'blog.review', resource: 'blog' },
      { type: 'can', action: 'blog.publish', resource: 'blog' },
    ],
    children: [
      // Artículos avanzados
      { id: 'blog.articles', labelKey: 'admin.menu.blog.articles', to: '/admin/blog/articles', policies: [
        { type: 'can', action: 'blog.article.view', resource: 'blog' }
      ] },
      { id: 'blog.articles.create', labelKey: 'admin.menu.blog.articles.create', to: '/admin/blog/articles/create', policies: [
        { type: 'can', action: 'blog.article.create', resource: 'blog' }
      ] },
      { id: 'blog.articles.drafts', labelKey: 'admin.menu.blog.articles.drafts', to: '/admin/blog/articles/drafts', policies: [
        { type: 'can', action: 'blog.article.view', resource: 'blog' }
      ] },
      { id: 'blog.articles.scheduled', labelKey: 'admin.menu.blog.articles.scheduled', to: '/admin/blog/articles/scheduled', policies: [
        { type: 'can', action: 'blog.article.view', resource: 'blog' }
      ] },
      { id: 'blog.articles.archived', labelKey: 'admin.menu.blog.articles.archived', to: '/admin/blog/articles/archived', policies: [
        { type: 'can', action: 'blog.article.view', resource: 'blog' }
      ] },
      { id: 'blog.categories', labelKey: 'admin.menu.blog.categories', to: '/admin/blog/categories', policies: [{ type: 'can', action: 'blog.taxonomy.manage', resource: 'blog' }] },
      { id: 'blog.tags', labelKey: 'admin.menu.blog.tags', to: '/admin/blog/tags', policies: [{ type: 'can', action: 'blog.taxonomy.manage', resource: 'blog' }] },
      { id: 'blog.media', labelKey: 'admin.menu.blog.media', to: '/admin/blog/media', policies: [{ type: 'can', action: 'blog.media.manage', resource: 'blog' }] },
      { id: 'blog.comments', labelKey: 'admin.menu.blog.comments', to: '/admin/blog/comments', policies: [{ type: 'can', action: 'blog.comments.moderate', resource: 'blog' }] },
      { id: 'blog.calendar', labelKey: 'admin.menu.blog.calendar', to: '/admin/blog/calendar', policies: [{ type: 'can', action: 'blog.article.view', resource: 'blog' }] },
      { id: 'blog.analytics', labelKey: 'admin.menu.blog.analytics', to: '/admin/blog/analytics', policies: [{ type: 'can', action: 'blog.analytics.view', resource: 'blog' }] },
      { id: 'blog.settings', labelKey: 'admin.menu.blog.settings', to: '/admin/blog/settings', policies: [{ type: 'can', action: 'blog.settings.manage', resource: 'blog' }] },
      { id: 'blog.import', labelKey: 'admin.menu.blog.import', to: '/admin/blog/import-export', policies: [{ type: 'can', action: 'blog.import', resource: 'blog' }] },
      { id: 'blog.export', labelKey: 'admin.menu.blog.export', to: '/admin/blog/import-export', policies: [{ type: 'can', action: 'blog.export', resource: 'blog' }] },
    ],
  },
  {
    id: 'community',
    labelKey: 'admin.menu.community',
    policies: [
      { type: 'can', action: 'community.view', resource: 'community' },
      { type: 'can', action: 'community.manage', resource: 'community' },
      { type: 'can', action: 'community.moderate', resource: 'community' },
    ],
    children: [
      { id: 'community.manage', labelKey: 'admin.menu.community.manage', to: '/admin/not-implemented', policies: [{ type: 'can', action: 'community.manage', resource: 'community' }] },
      { id: 'community.moderate', labelKey: 'admin.menu.community.moderate', to: '/admin/not-implemented', policies: [{ type: 'can', action: 'community.moderate', resource: 'community' }] },
    ],
  },
  {
    id: 'discounts',
    labelKey: 'admin.menu.discounts.manage',
    to: '/admin/not-implemented',
    policies: [{ type: 'can', action: 'discount.manage', resource: 'discounts' }],
  },
  {
    id: 'memberships',
    labelKey: 'admin.menu.memberships.manage',
    to: '/admin/not-implemented',
    policies: [
      { type: 'can', action: 'membership.view', resource: 'memberships' },
      { type: 'can', action: 'membership.manage', resource: 'memberships' },
    ],
  },
  {
    id: 'audit',
    labelKey: 'admin.menu.audit',
    to: '/admin/audit',
    policies: [{ type: 'role', role: 'admin_general' }],
  },
];

export default ADMIN_MENU;
